<template>
  <div>
    <!-- 头部 class="top-style" -->
    <div :class="visual === 1 ? 'tops-style' : 'top-style'">
      <div class="logo-style">
        <img src="@/assets/img/Layout/logo.png" @click="toPath" alt="" />
      </div>
      <div class="routeList-style">
        <div
          :class="
            state === 0 ? 'routeListlabel-stylechoice' : 'routeListlabel-style'
          "
          @click="jumpPathx(1)"
        >
          首页
        </div>
        <div
          :class="
            state === 1 ? 'routeListlabel-stylechoice' : 'routeListlabel-style'
          "
          @click="jumpPathx(2)"
        >
          关于我们
        </div>
        <div
          :class="
            state === 2
              ? 'routeListlabelproduct-stylechoice'
              : 'routeListlabelproduct-style'
          "
        >
          <div>产品</div>
          <div class="dropdown-style">
            <div style="display: flex">
              <div class="dropdownleft-style">
                <div v-for="(item, index) in productTopList" :key="index">
                  <div
                    class=""
                    :class="
                      productToptextstate === index
                        ? 'productToptext-stylechoice'
                        : 'productToptext-style'
                    "
                    @mouseover="hoverItem(index)"
                    @mouseout="unhoverItem(index)"
                    @click.stop="changeitem(item, index)"
                  >
                    <div style="margin-left: 30%">{{ item.label }}</div>
                  </div>
                </div>
              </div>
              <div class="dropdownright-style" v-if="productTopsubordinateList.length>0">
                <div
                  v-for="(item, index) in productTopsubordinateList"
                  :key="index"
                  @click.stop="changeitemsubordinate(item, index)"
                >
                  <div
                    class=""
                    :class="
                      productToptextsubordinatestate === index
                        ? 'productToptext-stylechoice'
                        : 'productToptext-style'
                    "
                  >
                    <div style="margin-left: 35%">{{ item.label }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="
            state === 3 ? 'routeListlabel-stylechoice' : 'routeListlabel-style'
          "
          @click="jumpPathx(4)"
        >
          新闻
        </div>
        <div
          :class="
            state === 4 ? 'routeListlabel-stylechoice' : 'routeListlabel-style'
          "
          @click="jumpPathx(5)"
        >
          支持中心
        </div>
        <div
          :class="
            state === 5 ? 'routeListlabel-stylechoice' : 'routeListlabel-style'
          "
          @click="jumpPathx(6)"
        >
          联系我们
        </div>
      </div>
    </div>
    <slot></slot>
    <!-- 底部 -->
    <div class="bottom-style">
      <div class="bottomleft-style">
        <div class="bottomleftdetailed-style">
          <img src="@/assets/img/Layout/logo.png" alt="" />
          <div style="display: flex; margin-top: 29px">
            <div class="leftone-style">
              <img
                style="width: 100%"
                src="https://jiwatewebserver.obs.cn-southwest-2.myhuaweicloud.com/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E4%BA%AC%E4%B8%9C%E5%BA%97%E9%93%BA%E4%BA%8C%E7%BB%B4%E7%A0%81.png"
                alt=""
              />
            </div>

            <div class="lefttwo-style">
              <img
                style="width: 100%"
                src="https://jiwatewebserver.obs.cn-southwest-2.myhuaweicloud.com/%E4%BA%8C%E7%BB%B4%E7%A0%81/%E6%99%BA%E5%B2%9A%E6%9C%AA%E6%9D%A5%E5%85%AC%E4%BC%97%E5%8F%B7%E4%BA%8C%E7%BB%B4%E7%A0%81.jpg"
                alt=""
              />
            </div>
          </div>
          <div class="bottomtext-style">{{ text }}</div>
        </div>
      </div>
      <div class="bottomright-style">
        <div style="display: flex; margin-top: 40px; cursor: pointer">
          <div v-for="(item, index) in routeList" :key="index">
            <div
              class="itemone-style"
              :class="{ 'itemover-style': index !== 0 }"
              @click="jumpPath(item, inedx)"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div style="margin-left: 29.5%; margin-top: 16px">
            <div v-for="(item, index) in productList" :key="index">
              <div
                class="productiem-style"
                :class="{ 'productiemover-style': index !== 0 }"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
          <div style="margin-left: 21%; margin-top: 16px">
            <div v-for="(item, index) in supportList" :key="index">
              <div
                class="productiem-style"
                :class="{ 'productiemover-style': index !== 0 }"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
          <div style="margin-left: 11%; margin-top: 16px">
            <div v-for="(item, index) in contactList" :key="index">
              <div
                class="productiem-style"
                :class="{ 'productiemover-style': index !== 0 }"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    visual: Number,
    state: Number,
    stateNumstate: Number,
  },
  components: {},
  data() {
    return {
      // state: -1,
      routeList: [
        {
          label: "首页",
          path: "/",
        },
        {
          label: "关于我们",
          path: "/aboutUs",
        },
        {
          label: "产品",
          path: "/product",
        },
        {
          label: "新闻",
          path: "/journalism",
        },
        {
          label: "支持中心",
          path: "/supportCenter",
        },
        {
          label: "联系我们",
          path: "/contactus",
        },
      ],
      productList: [
        {
          label: "实验电源",
        },
        {
          label: "光伏逆变器",
        },
        {
          label: "储能电源",
        },
        {
          label: "设备电源",
        },
        {
          label: "充电桩",
        },
      ],
      supportList: [
        {
          label: "产品手册",
        },
        {
          label: "用户手册",
        },
        {
          label: "软件下载",
        },
      ],
      contactList: [
        {
          label: "电话：86-28-60911798",
        },
        {
          label: "邮箱：cdgwt@gwattstar.com",
        },
        {
          label: "地址：成都市温江区科源路518号",
        },
      ],
      text: "Copyright © 成都吉瓦特科技有限公司 蜀ICP备2023009394",
      productTopList: [
        {
          label: "智能充电桩",
        },
        {
          label: "实验电源",
        },
        {
          label: "设备电源",
        },
        {
          label: "光伏逆变器",
        },
        {
          label: "车载充电机",
        },
         {
          label: "集成测试系统",
        },
        
      ],
      productTopsubordinateList: [
        // {
        //   label: "3.5KW",
        // },
        // {
        //   label: "7KW",
        // },
        // {
        //   label: "11KW",
        // },
      ],
      productToptextstate: -1,
      productToptextsubordinatestate: -1,
      type: null,
      typeProperty: null,
    };
  },

  created() {},

  mounted() {},

  methods: {
    hoverItem(index) {
      let indexx = index;
      this.productToptextstate = index;
      if (indexx == 0) {
        this.type = 1;
        this.productTopsubordinateList = [
          {
            label: "3.5KW",
          },
          {
            label: "7KW",
          },
          {
            label: "11KW",
          },
          {
            label: "22KW",
          },
        ];
      }
      if (indexx == 1) {
        this.type = 4;
        this.productTopsubordinateList = [
          {
            label: "单路",
          },
          {
            label: "多路",
          },
        ];
      }
      if (indexx == 2) {
        this.type = 5;
        this.productTopsubordinateList = [
          {
            label: "模块电源",
          },
          {
            label: "板卡电源",
          },
        ];
      }
      if (indexx == 3) {
        this.type = 3;
        this.productTopsubordinateList = [
          {
            label: "600W",
          },
        ];
      }
      if (indexx == 4) {
        this.type = 2;
        this.productTopsubordinateList = [
          {
            label: "铅酸版",
          },
           {
            label: "锂电版",
          },
        ];
      }
       if (indexx == 5) {
        this.type = 6;
        this.productTopsubordinateList = [
          // {
          //   label: "铅酸版",
          // },
          //  {
          //   label: "锂电版",
          // },
        ];
      }
    },
    unhoverItem(inedx) {
      //  console.log(inedx);
    },
    changeitem(e, i) {
      this.productToptextstate = i;
      if (e.label == "智能充电桩") {
        this.type = 1;
        this.productTopsubordinateList = [
          {
            label: "3.5KW",
          },
          {
            label: "7KW",
          },
          {
            label: "11KW",
          },
          {
            label: "22KW",
          },
        ];
        // this.$router.push({
        //   path: "/product",
        //   query: { type: this.type },
        // });
        // this.$forceUpdate();
        this.$router
          .replace({
            path: "/product",
            query: { type: this.type },
          })
          .then(() => {
            this.$router.go(0);
          });
        // window.location.reload();
      }
      if (e.label == "实验电源") {
        this.type = 4;
        this.productTopsubordinateList = [
          {
            label: "单路",
          },
          {
            label: "多路",
          },
        ];
        this.$router
          .replace({
            path: "/product",
            query: { type: this.type },
          })
          .then(() => {
            this.$router.go(0);
          });
        // window.location.reload();
      }
      if (e.label == "设备电源") {
        this.type = 5;
        this.productTopsubordinateList = [
          {
            label: "模块电源",
          },
          {
            label: "板卡电源",
          },
        ];
        this.$router
          .replace({
            path: "/product",
            query: { type: this.type },
          })
          .then(() => {
            this.$router.go(0);
          });
        // window.location.reload();
      }
      if (e.label == "光伏逆变器") {
        this.type = 3;
        this.productTopsubordinateList = [
          {
            label: "600W",
          },
        ];
        this.$router
          .replace({
            path: "/product",
            query: { type: this.type },
          })
          .then(() => {
            this.$router.go(0);
          });
        // window.location.reload();
      }
      if (e.label == "车载充电机") {
        this.type = 2;
        this.productTopsubordinateList = [
           {
            label: "铅酸版",
          },
           {
            label: "锂电版",
          },
        ];
        this.$router
          .replace({
            path: "/product",
            query: { type: this.type },
          })
          .then(() => {
            this.$router.go(0);
          });
        // window.location.reload();
      }
         if (e.label == "集成测试系统") {
        this.type = 6;
        this.productTopsubordinateList = [];
        this.$router
          .replace({
            path: "/product",
            query: { type: this.type },
          })
          .then(() => {
            this.$router.go(0);
          });
        // window.location.reload();
      }
    },
    changeitemsubordinate(e, i) {
      if (i == 0) {
        this.typeProperty = 1;

        this.$router
          .replace({
            path: "/product",
            query: { type: this.type, typeProperty: this.typeProperty },
          })
          .then(() => {
            this.$router.go(0);
          });
      }
      if (i == 1) {
        this.typeProperty = 2;

        this.$router
          .replace({
            path: "/product",
            query: { type: this.type, typeProperty: this.typeProperty },
          })
          .then(() => {
            this.$router.go(0);
          });
      }
      if (i == 2) {
        this.typeProperty = 3;
        this.$router
          .replace({
            path: "/product",
            query: { type: this.type, typeProperty: this.typeProperty },
          })
          .then(() => {
            this.$router.go(0);
          });
      }
      if (i == 3) {
        this.typeProperty = 4;
        this.$router
          .replace({
            path: "/product",
            query: { type: this.type, typeProperty: this.typeProperty },
          })
          .then(() => {
            this.$router.go(0);
          });
      }
    },
    jumpPath(e, index) {
      // this.state = index;
      if (e.label !== "产品") {
        this.$router.push(e.path);
      }
    },
    jumpPathx(e) {
      if (e == 1) {
        this.$router.push("/");
      }
      if (e == 2) {
        this.$router.push("/aboutUs");
      }
      if (e == 3) {
        this.$router.push("/product");
      }
      if (e == 4) {
        this.$router.push("/journalism");
      }
      if (e == 5) {
        this.$router.push("/supportCenter");
      }
      if (e == 6) {
        this.$router.push("/contactus");
      }
    },
    toPath() {
      this.$router.push("/");
    },
  },

  computed: {},

  watch: {},
};
</script>

<style lang='scss' scoped>
.dropdown-style {
  width: 400px;
  position: absolute;
  left: 51%;
  top: 80px;

  display: none;
  // opacity: 0; /* 初始状态设置透明度为0，不可见 */
  // transition: opacity 0.5s ease-out; /* 设置透明度变化的过渡效果 */
}
.dropdownleft-style {
  width: 200px;
  // height: 280px;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(115, 115, 154, 0.12);
  border-radius: 0px 0px 0px 0px;
}
.dropdownright-style {
  width: 200px;
  // height: 280px;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(115, 115, 154, 0.12);
  border-radius: 0px 0px 0px 0px;
  display: none;
  // opacity: 0; /* 初始状态设置透明度为0，不可见 */
  // transition: opacity 0.5s ease-out; /* 设置透明度变化的过渡效果 */
}
.dropdownleft-style:hover + .dropdownright-style {
  display: block;
  // opacity: 1; /* 鼠标悬停时设置透明度为1，可见 */
  // visibility: visible;
}
.dropdownright-style:hover {
  display: block;
}
.top-style {
  width: 100%;
  height: 80px;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  // color: white;
  color: black;
}
.tops-style {
  width: 100%;
  height: 80px;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  color: black;
  background: white;
}
.logo-style {
  margin-top: 1%;
  margin-left: 8.3%;
}
.routeList-style {
  margin-left: 20%;
  display: flex;
  margin-top: 1.5%;
  width: 50%;
  cursor: pointer;
}
.routeListlabel-style {
  // width: 100%;
  margin-left: 90px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  font-style: normal;
  text-transform: none;
}
.routeListlabel-stylechoice {
  color: #0a5d9c;
  margin-left: 90px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  font-style: normal;
}
.routeListlabelproduct-style {
  // width: 100%;
  margin-left: 90px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  font-style: normal;
  text-transform: none;
}
.routeListlabelproduct-stylechoice {
  color: #0a5d9c;
  margin-left: 90px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  font-style: normal;
}
.routeListlabelproduct-style:hover > .dropdown-style {
  display: block;
  // opacity: 1; /* 鼠标悬停时设置透明度为1，可见 */
  // visibility: visible;
}
.routeListlabelproduct-stylechoice:hover > .dropdown-style {
  display: block;
  // opacity: 1; /* 鼠标悬停时设置透明度为1，可见 */
  // visibility: visible;
}
.multilingual-style {
  width: 5%;
  margin-left: 4%;
  margin-top: 1.7%;
}
.bottom-style {
  // position: fixed;
  // bottom: 0;
  // left: 0;
  width: 100%;
  // height: 288px;
  background: #f0f0f0;
  border-radius: 0px 0px 0px 0px;
  display: flex;
  .bottomleft-style {
    width: 38%;
    height: 100%;

    .bottomleftdetailed-style {
      margin-left: 22%;
      margin-top: 40px;
    }
    .leftone-style {
      width: 100px;
      height: 100px;
      background: #ffffff;
      border-radius: 0px 0px 0px 0px;
    }
    .lefttwo-style {
      width: 100px;
      height: 100px;
      background: #ffffff;
      border-radius: 0px 0px 0px 0px;
      margin-left: 20px;
    }
    .bottomtext-style {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #919399;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 73px;
    }
  }
  .bottomright-style {
    width: 62%;
    height: 100%;

    .itemone-style {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #303133;
      line-height: 28px;
      font-style: normal;
      text-transform: none;
    }
    .itemover-style {
      width: 100%;
      margin-left: 120px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #303133;
      line-height: 28px;
      font-style: normal;
      text-transform: none;
    }
    .productiem-style {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #616266;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
    }
    .productiemover-style {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #616266;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-top: 8px;
      cursor: pointer;
    }
  }
}
.productToptext-style {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #303133;
  line-height: 56px;
  // text-align: center;
  // font-style: normal;
  // text-transform: none;
}
.productToptext-stylechoice {
  width: 100%;
  height: 56px;
  background: #f9f9fc;
  border-radius: 0px 0px 0px 0px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #0a5d9c;
  line-height: 56px;
  // text-align: center;
  // font-style: normal;
  // text-transform: none;
}
.productToptext-style:hover {
  width: 100%;
  height: 56px;
  background: #f9f9fc;
  border-radius: 0px 0px 0px 0px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #0a5d9c;
  line-height: 56px;
  // text-align: center;
  // font-style: normal;
  // text-transform: none;
}
</style>